












import Vue from 'vue';

export default Vue.extend({
	name: 'MoonLoaderTitle',
	props: {
    imageSource:String,
    iconClass: String,
		loading: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: '<bind title>',
		},
  },
});
